import DualloUserClient from "@/clients/duallo/DualloUserClient";
import UpdateDualloUserModel from "@/domain/UpdateDualloUserModel";

class DualloUserService {
    async getUserProfileAsync(organizationId, userId) {
        return await DualloUserClient.getUserAsync(organizationId, userId);
    }

    async acceptTermsofService(organizationId, userId) {
        const userProfile = await this.getUserProfileAsync(organizationId, userId);
        const updateRequest = this.getAcceptedToSUpdateRecord(userProfile);
        return await this.updateRecord(updateRequest);
    }

    getAcceptedToSUpdateRecord(userProfile) {
        return new UpdateDualloUserModel(
            userProfile.organizationId,
            userProfile.id,
            true,
            new Date().toISOString(),
            userProfile.eTag);
    }

    async updateRecord(record) {
        return await DualloUserClient.updateUserRecord(record);
    }

    async generateSasToken(organizationId, userId) {
        return await DualloUserClient.generateSaSToken(organizationId, userId);
    }
}

export default DualloUserService;